<template>
  <div class="group-filter-bg px-md-4 py-md-4">
    <div class="row pt-0 mr-lg-4 justify-content-between">
      <div :class="`col-sm-6 col-xl-${col}`">
        <div class="form-group">
          <input
            v-model.trim="firstName"
            id="firstName"
            name="firstName"
            type="text"
            autofocus
            placeholder="Prénom"
            class="form-control"
          />
        </div>
      </div>
      <div :class="`col-sm-6 col-xl-${col}`">
        <div class="form-group">
          <input
            v-model.trim="lastName"
            id="lastName"
            name="lastName"
            type="text"
            autofocus
            placeholder="Nom"
            class="form-control"
          />
        </div>
      </div>
    </div>
    <div class="row pt-0 mr-lg-4 justify-content-between">
      <!-- Group Filter -->

      <div
        :class="`col-sm-6 col-xl-${col}`"
        v-if="$route.path != '/personalTasks'"
      >
        <div class="group-filter">
          <div class="form-group">
            <select class="form-control" v-model="selectedStatus">
              <option value="">Statut</option>
              <option
                v-for="(status, index) in statusList"
                :value="status"
                :key="index"
              >
                {{
                  statusListTranslation[status]
                    ? statusListTranslation[status]
                    : "En attente"
                }}
              </option>
            </select>
            <div class="select-down">
              <img
                class="select-down__icon"
                src="@/assets/images/down-arrow.svg"
                alt="Arrow Icon"
                aria-hidden="true"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        :class="`col-sm-6 col-xl-${col}`"
        v-if="$route.path != '/personalTasks'"
      >
        <div class="group-filter">
          <div class="form-group">
            <select class="form-control" v-model="type">
              <option value="">Type</option>
              <option
                v-for="(type, index) in typesList"
                :value="type"
                :key="index"
              >
                {{ daysOffList[type].name }}
              </option>
            </select>
            <div class="select-down">
              <img
                class="select-down__icon"
                src="@/assets/images/down-arrow.svg"
                alt="Arrow Icon"
                aria-hidden="true"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- Report for Filter -->
      <div :class="`col-sm-6 col-xl-${col} mb-3 mb-md-0`">
        <div class="d-flex common-filter">
          <div class="p-2 icon">
            <i class="far fa-calendar"></i>
          </div>
          <div>
            <d-datepicker
              v-model="startDate"
              placeholder="date début"
              :language="fr"
              small
              typeable
            />
          </div>
        </div>
      </div>
      <!-- Date added -->
      <div :class="`col-sm-6 col-xl-${col} mb-3 mb-xl-0`">
        <div class="d-flex common-filter">
          <div class="p-2 icon">
            <i class="far fa-calendar"></i>
          </div>
          <div>
            <d-datepicker
              v-model="endDate"
              placeholder="Date fin"
              :language="fr"
              small
              typeable
            />
          </div>
        </div>
      </div>
      <!-- Apply Button -->
      <div :class="`only-desk-top col-sm-6 col-xl-${col} mb-3 mb-md-0 d-flex`">
        <div class="task-manager-apply" style="margin-left: 5px">
          <button class="btn btn-primary" @click="saveSearch()">
            {{ $t("global.apply") }}
          </button>
        </div>
        <div class="task-manager-apply" style="margin-left: 5px">
          <button class="btn btn-primary" @click="refresh()">
            {{ $t("global.reset") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { fr } from "vuejs-datepicker/dist/locale";
import daysOffType from "../../data/daysOff/daysOffType";

export default {
  data() {
    return {
      selectedStatus: "",
      startDate: "",
      endDate: "",
      type: "",
      daysOffList: daysOffType,
      typesList: Object.keys(daysOffType),
      hideGroupFilter: true,
      fr,
      statusListTranslation: {
        ACCEPTED: "Approuvé",
        REFUSED: "Rejeté",
        CANCELED: "Annulée"
      },
      firstName: "",
      lastName: ""
    };
  },
  props: ["statusList"],
  mounted() {
    const start = new Date();
    const end = new Date();
    const filter = this.$store.state.absenceRequest.filter;

    this.selectedStatus = filter.status ? filter.status : "";
    if (filter.dates) {
      if (filter.dates.from) {
        start.setTime(filter.dates.from);
      }

      this.startDate = filter.dates.from ? start : "";
      if (filter.dates.to) {
        end.setTime(filter.dates.to);
      }
      this.endDate = filter.dates.to ? end : "";
    } else {
      this.startDate = "";

      this.endDate = "";
    }
    this.type = filter.type ? filter.type : "";
  },
  computed: {
    col() {
      return this.hideGroupFilter ? 3 : 3;
    }
  },
watch : {
startDate(newv,old){

    this.startDate=newv===null ?old : newv

}
,
endDate(newv,old){

    this.endDate=newv===null ?old : newv

}
},
  methods: {
    saveSearch() {
      const obj = {};
      if (this.firstName) {
        obj.firstName = this.firstName;
      }
      if (this.lastName) {
        obj.lastName = this.lastName;
      }
      if (this.selectedStatus !== "") {
        obj.status = this.selectedStatus;
      }
      if (this.startDate !== "" || this.endDate !== "") {
        console.log(this.startDate)
        obj.dates = {
          from:
            this.startDate === ""
              ? undefined
              : new Date(this.startDate).getTime(),
          to: this.endDate === "" ? undefined : new Date(this.endDate).getTime()
        };
      }
      if (this.type !== "") {
        obj.type = this.type;
      }
      this.$store.dispatch("setFilter", obj);
      this.$root.$emit("searchRequests", obj);
    },

    refresh() {
      this.selectedStatus = "";
      this.startDate = "";
      this.endDate = "";
      this.type = "";
      this.name = "";
      this.saveSearch();
    }
  }
};
</script>
<style lang="scss">
.form-control {
  background-color: #fff !important;
}
.group-filter {
  position: relative;
  select {
    background: white !important;
    color: black !important;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4) !important;
    background-repeat: no-repeat;
    -webkit-appearance: none;
    -moz-appearance: none;
    position: relative;
  }
  .select-down {
    position: absolute;
    right: 10px;
    top: 5px;
    &__icon {
      width: 13px;
    }
  }
}
.task-manager-apply {
  .task-manager-btn {
    width: 110px;
    height: 36px;
    border: 0;
    background-color: #4f78e2;
    color: #fff;
    font-family: "SF-Pro-Text";
    border-radius: 3px;
    font-size: 14px;
    margin-right: 15px; //9
    outline: none;
  }
}
</style>
